/**
 * Microsoft Clarity adapter, using Microsoft's official `@microsoft/clarity`
 * NPM package (their recommended installation method).
 *
 * Auth compatibility: Clarity is a passive session-recording/heatmap
 * script — it does not touch cookies/headers used by our JWT + httpOnly
 * cookie auth, and by default it auto-masks password fields and other
 * sensitive inputs. We never feed it auth tokens, emails, or names.
 */
import Clarity from "@microsoft/clarity";

let clarityInitialized = false;

export function initClarity(projectId) {
  if (!projectId || clarityInitialized) return;
  try {
    Clarity.init(projectId);
    clarityInitialized = true;
  } catch {
    // A third-party analytics failure must never break the app.
  }
}

export function trackClarityEvent(name) {
  if (!clarityInitialized || !name) return;
  try {
    Clarity.event(name);
  } catch {
    // no-op
  }
}
